import { useTheme } from '@emotion/react';
import { Image, openUrl, useBreakpoints } from '@nettbureau/featured-core';
import { Button, Card, Stack, Text, VStack } from '@nettbureau/vibrant-ui';
import { useTranslate } from '@tolgee/react';
import { useContext } from 'react';
import { ConfigContext } from '../provider/config-provider';
import { getTheme, getTokenFromVibrant } from '../theme';
import { CardTitle } from './CardTitle';

interface LocationCardProps {
  name: string;
  index: number;
  internalLink: string | null;
  background: Image | null;
}

export function LocationCard({
  name,
  index,
  background,
  internalLink,
}: LocationCardProps) {
  const { isMobile } = useBreakpoints();

  const { t } = useTranslate();

  const vibrantTheme = useTheme();

  const { theme } = useContext(ConfigContext);

  return (
    <Card key={index} variant="elevated">
      <Stack
        gap="md"
        align="center"
        justify="center"
        direction={isMobile ? 'vertical' : 'horizontal'}
      >
        <div style={{ width: isMobile ? '100%' : 300 }}>
          <div
            style={{
              borderTopLeftRadius: vibrantTheme.borderRadiuses.md,
              borderTopRightRadius: isMobile
                ? vibrantTheme.borderRadiuses.md
                : 0,
              borderBottomLeftRadius: !isMobile
                ? vibrantTheme.borderRadiuses.md
                : 0,
              borderBottomRightRadius: isMobile
                ? vibrantTheme.borderRadiuses.md
                : 0,
              background:
                background !== null
                  ? `url(${background.url})`
                  : getTokenFromVibrant(
                      getTheme(theme).default.card.cardHeaderBackground,
                      vibrantTheme,
                    ),
              backgroundSize: 'cover',
              width: '100%',
              maxWidth: '100%',
              height: 150,
            }}
          />
        </div>

        <VStack
          padding={isMobile ? 'md' : 0}
          justify="center"
          align="center"
          width={80}
          gap="md"
        >
          <CardTitle href={null} title={name} />

          <Button
            color="gray"
            onPress={() => internalLink && openUrl(internalLink, false)}
            css={(vibrantTheme) => ({
              background: getTokenFromVibrant(
                getTheme(theme).cityListPage.card.cardButton,
                vibrantTheme,
              ),
            })}
          >
            <Text data-featured-city-list-offers-from>
              {t('get_offers_from')} {name}
            </Text>
          </Button>
        </VStack>
      </Stack>
    </Card>
  );
}
